import {Component, Input, OnInit, TemplateRef, ViewChild} from '@angular/core';
import {TaskLifeModel} from '../../../models/task.model';
import {HelpersService} from '../../../services/helpers.service';
import {CrmService} from '../../../services/api/crm.service';
import {ModalService} from '../../../services/modal/modal.service';
import {PaginationModel} from '../../../models/file-table.model';
import {MemberService} from '../../../services/member.service';
import {TranslateService} from '@ngx-translate/core';

@Component({
    selector: 'app-task-detail-logs',
    templateUrl: './task-detail-logs.component.html',
    styleUrls: ['./task-detail-logs.component.scss'],
})
export class TaskDetailLogsComponent implements OnInit {

    @ViewChild('taskView') public viewTask: TemplateRef<any>;

    @Input() public taskAlias: string;
    @Input() public boardLife: TaskLifeModel[];

    public loadingLife = true;
    public taskLifeData: TaskLifeModel[] = [];

    public pagination: PaginationModel = {
        limit: 25,
        current_page: 1,
        pages: 1,
    };


    constructor(
        public helper: HelpersService,
        protected crmService: CrmService,
        public modalService: ModalService,
        private memberService: MemberService,
        public translate: TranslateService
    ) {
    }

    ngOnInit(): void {
        if (!this.boardLife) {
            void this.getLife();
        } else {
            this.taskLifeData = this.boardLife;
            this.getMembers();
        }
    }

    async getLife(): Promise<void> {
        this.loadingLife = true;
        this.crmService.getTaskLifeByAlias(this.taskAlias, this.pagination).subscribe(res => {
            this.taskLifeData = res.data;
            this.pagination.pages = res.page_count;
            this.getMembers();
        });
    }

    getMembers(): void {
        const membersGuids: string[] = this.taskLifeData.map(x => {
            return x.instance.user_guid;
        });

        this.memberService.memberGuidsHandler(membersGuids).then(members => {
            this.taskLifeData.forEach(life => {
                life.user = life.instance.member = members.find(member => member.guid === life.instance.user_guid);
            });

            this.taskLifeData.map(x => x.wrap = this.lifeWrapper(x));
            this.loadingLife = false;
        });
    }

    lifeWrapper(log: TaskLifeModel): { title: string, body: { key: string, data: any } } {
        const titleN = log.event_type !== 'change_task' ? log.event_type : log.instance.field;
        let bodyN: {
            key: string,
            data: any,
        };
        switch (log.event_type) {
            case 'status_change':
                bodyN = {
                    key: log.event_type,
                    data: {
                        old_status: log.instance.old_status,
                        new_status: log.instance.new_status,
                    }
                };
                break;

            case 'user_add':
                bodyN = {
                    key: log.event_type,
                    data: {
                        role: this.translate.instant('TASKS.LOGS.ROLES.' + log.instance.role),
                        name: this.helper.shortFullName(log.instance.member, !this.boardLife)
                    }
                };
                break;

            case 'user_remove':
                bodyN = {
                    key: log.event_type,
                    data: {
                        name: this.helper.shortFullName(log.instance.member, !this.boardLife)
                    }
                };
                break;

            case 'collection_add':
            case 'collection_remove':
                bodyN = {
                    key: log.event_type,
                    data: {
                        name: log.instance ? log.instance.name : log.instance_id
                    }
                };
                break;

            case 'comment_add':
            case 'comment_delete':
                bodyN = {
                    key: log.event_type,
                    data: {
                        comment: log.instance.comment
                    }
                };
                break;

            case 'comment_update':
                bodyN = {
                    key: log.event_type,
                    data: {
                        comment_old: log.instance.old_val,
                        comment_new: log.instance.new_val,
                    }
                };
                break;

            case 'subtask_add':
            case 'subtask_remove':
                bodyN = {
                    key: log.event_type,
                    data: {
                        task: log.instance.sub_task.title,
                    }
                };
                break;

            case 'photo_add':
            case 'photo_delete':
                bodyN = {
                    key: log.event_type,
                    data: {
                        name: log.instance.name,
                    }
                };
                break;

            case 'property_add':
            case 'property_remove':
                bodyN = {
                    key: log.event_type,
                    data: {
                        name: log.instance.title,
                    }
                };
                break;

            // todo будут изменения логов property_update, переделать
            case 'property_update':
                bodyN = {
                    key: log.event_type,
                    data: {
                        name: log.instance.field,
                        old_val: log.instance.old_val,
                        new_val: log.instance.new_val,
                    }
                };
                break;

            case 'change_task':
                bodyN = this.changeTaskLifeWrapper(log.instance);
                break;
        }
        return {title: titleN, body: bodyN};
    }

    changeTaskLifeWrapper(logInstance): { key: string, data: any } {
        let bodyN: {
            key: string,
            data: any
        };
        switch (logInstance.field) {
            case 'importance':
                bodyN = {
                    key: logInstance.field,
                    data: {
                        old_val: this.translate.instant('TASKS.LOGS.IMPORTANCE.' + logInstance.old_val),
                        new_val: this.translate.instant('TASKS.LOGS.IMPORTANCE.' + logInstance.new_val),
                    }
                };
                return bodyN;

            case 'importance_index':
                bodyN = {
                    key: logInstance.field,
                    data: {
                        old_val: logInstance.old_val,
                        new_val: logInstance.new_val,
                    }
                };
                return bodyN;

            case 'task_type_id':
                bodyN = {
                    key: logInstance.field,
                    data: {
                        old_name: logInstance.old_val ? logInstance.old_val.name : this.translate.instant('TASKS.LOGS.DELETED'),
                        old_icon: logInstance.old_val ? logInstance.old_val.icon : '',
                        new_name: logInstance.new_val ? logInstance.new_val.name : this.translate.instant('TASKS.LOGS.DELETED'),
                        new_icon: logInstance.new_val ? logInstance.new_val.icon : ''
                    }
                };
                return bodyN;

            case 'title':
                bodyN = {
                    key: logInstance.field,
                    data: {
                        old_val: logInstance.old_val,
                        new_val: logInstance.new_val,
                    }
                };
                return bodyN;

            case 'content':
                bodyN = {
                    key: logInstance.field,
                    data: {
                        old_val: logInstance.old_val||this.translate.instant('TASKS.LOGS.TITLE.content_null'),
                        new_val: logInstance.new_val||this.translate.instant('TASKS.LOGS.TITLE.content_null'),
                    }
                };
                return bodyN;

            case 'deadline_at':
                if (!logInstance.old_val) {
                    bodyN = {
                        key: 'deadline_at_set',
                        data: {
                            new_val: logInstance.new_val,
                        }
                    };
                } else {
                    bodyN = {
                        key: logInstance.field,
                        data: {
                            old_val: logInstance.old_val,
                            new_val: logInstance.new_val,
                        }
                    };
                }
                return bodyN;

            case 'duration':
                if (!logInstance.old_val) {
                    bodyN = {
                        key: 'deadline_at_set',
                        data: {
                            new_val: this.helper.getTimeFromMinute(logInstance.new_val),
                        }
                    };
                } else {
                    bodyN = {
                        key: logInstance.field,
                        data: {
                            old_val: this.helper.getTimeFromMinute(logInstance.old_val),
                            new_val: this.helper.getTimeFromMinute(logInstance.new_val),
                        }
                    };
                }
                return bodyN;

            case 'due_time':
                if (!logInstance.old_val) {
                    bodyN = {
                        key: 'due_time_set',
                        data: {
                            new_val: this.helper.formatDate(logInstance.new_val),
                        }
                    };
                } else {
                    bodyN = {
                        key: logInstance.field,
                        data: {
                            old_val: this.helper.formatDate(logInstance.old_val),
                            new_val: this.helper.formatDate(logInstance.new_val),
                        }
                    };
                }
                return bodyN;
        }
    }

    openTask(item: TaskLifeModel): void {
        if (!this.boardLife.length) {
            return;
        }
        this.taskAlias = item.task_alias;
        this.modalService.openTemplateModal(this.viewTask, 'xl');
    }

    changePage(page: number): void {
        this.pagination.current_page = page;
        void this.getLife();
    }
}
